import { render, staticRenderFns } from "./MainModalContainer.vue?vue&type=template&id=52d0197e&scoped=true&"
import script from "./MainModalContainer.vue?vue&type=script&lang=js&"
export * from "./MainModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./MainModalContainer.vue?vue&type=style&index=0&id=52d0197e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0197e",
  null
  
)

export default component.exports